module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0758.d0ae93ce.jpg";